// src/components/AlertPopup.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AlertPopup = ({ title, message, buttonLabel, redirectUrl, onClose }) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (redirectUrl) {
      navigate(redirectUrl);
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="alert-popup-container">
      <div className="alert-popup">
        <div className="alert-popup-icon">
          <i className="mdi mdi-check-circle alert-popup-icon-check"></i>
        </div>
        <p className="alert-popup-message">{title}</p>
        <p>{message}</p>
        {buttonLabel && (
          <button type="button" className="btn btn-primary" onClick={handleButtonClick}>
            {buttonLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default AlertPopup;
